import { BaseClass } from './base-class';
import { Site } from './site';

export class WaitingTime extends BaseClass {
  site: Site;
  minutes: number;
  price: number;
  nonHourlyPrice?: number;

  priceFormated?: number;

  constructor()
  constructor(
    site: Site, minutes: number, price: number, nonHourlyPrice: number)
  constructor(
    site?: Site, minutes?: number, price?: number, nonHourlyPrice?: number) {
    super();

    this.site = site;
    this.minutes = minutes;
    this.price = price;
    this.nonHourlyPrice = nonHourlyPrice;
  }

  static fromObject(object: WaitingTime): WaitingTime {
    return Object.assign(new WaitingTime(), {
      ...object,
      site: object.site ? Site.fromObject(object.site) : null,
    });
  }
}
